import React from "react";
import { Container, Typography, Paper, Box } from "@mui/material";





// privacyData.js
const privacyData = {
  lastUpdated: "2025/08/04",
  title: "Privacy Policy",
  intro: `We take your privacy seriously, and we encourage you to do the same. 
  This Privacy Policy is designed to clearly explain how we handle your personal 
  information, ensuring you understand what we do to keep it safe. 
  We recommend reading this document thoroughly and checking back periodically 
  for updates, as the most current version always applies.`,

  sections: [
    {
      heading: "What Does This Privacy Policy Cover?",
      content: `This Privacy Policy applies to all users (“you” or “your”) 
      of the www.yubai.ai website and Yubai mobile application (collectively, the “Platforms”) 
      as well as the features, products, and services offered through these Platforms (“Services”). 
      It describes how Yubai L.L.C-FZ... collects, uses, and protects your personal information.`,
    },
    {
      heading: "What This Privacy Policy Covers:",
      list: [
        "Information Collection – What data we gather from you and how",
        "Information Usage – How we utilize that information",
        "Data Protection – How we safeguard your information",
        "Information Sharing – What information is shared with others and under what circumstances",
        "Your Rights – Choices you have regarding your personal information",
        "By using our Platforms, you signify your consent to this policy...",
      ],
    },
    {
      heading: "Information Not Covered by This Privacy Policy",
      content: `Our Platforms may occasionally link to third-party platforms. 
      Their privacy practices are beyond our control and governed by their own privacy policies...`,
    },
    {
      heading: "Types of Information We Collect",
      subSections: [
        {
          subHeading: "1. Information You Provide:",
          list: [
            "When creating or updating your account, we may ask for details such as your name, email, phone number...",
            "For transactions or support inquiries, financial information may be collected.",
            "Participation in promotions, feedback submissions, or surveys may involve additional data collection.",
          ],
        },
        {
          subHeading: "2. Information We Collect Automatically:",
          list: [
            "Device data (IP address, browser type, location data)...",
            "Cookies and tracking tools for smoother experience.",
          ],
        },
        {
          subHeading: "3. Information From Other Sources:",
          list: [
            "We may supplement data with trusted partners or platforms (e.g., analytics tools or social media).",
          ],
        },
      ],
    },
    {
      heading: "How We Use Cookies",
      list: [
        "Maintain your login status",
        "Remember preferences",
        "Enhance user experience",
        "You can adjust your browser settings to control cookie behavior",
      ],
    },
    {
      heading: "How We Use Your Personal Information",
      list: [
        "Manage account creation, transactions, and deliveries",
        "Personalize your experience and improve service",
        "Fulfill legal and regulatory obligations",
        "Send marketing communications (opt-out anytime)",
      ],
    },
    {
      heading: "Information Sharing",
      list: [
        "With service providers, affiliates, or partners to fulfill requests",
        "In connection with business transfers like mergers or acquisitions",
        "To comply with legal obligations or protect against fraud",
        "We may also share anonymized, non-identifiable information",
      ],
    },
    {
      heading: "Data Retention",
      content: `We retain your data only as long as needed to fulfill its purpose or comply with applicable laws.`,
    },
    {
      heading: "Your Rights and Choices",
      list: [
        "Access, correct, or update your data",
        "Object to processing or request deletion (subject to service limitations)",
      ],
    },
    {
      heading: "Data Protection Measures",
      content: `We implement industry-standard security measures to protect your personal information. 
      However, no system is completely secure. If you suspect unauthorized activity, contact us immediately.`,
    },
    {
      heading: "Policy Updates",
      content: `We may update this Privacy Policy to reflect changes in technology, legal requirements, 
      or our business practices...`,
    },
    {
      heading: "Contact Us",
      content: `If you have any questions, concerns, or complaints regarding this Privacy Policy, contact us at:`,
      list: [
        "Yubai L.L.C-FZ",
        "Meydan Grandstand, 6th Floor, Meydan Road, Nad Al Sheba, Dubai, UAE",
        "Email: operations@yubai.ai",
      ],
    },
  ],
};




const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ mt: { xs: 2, sm: 4 }, mb: { xs: 2, sm: 6 } }}>
      <Box
        sx={{ padding: "10px", marginTop: "20px", marginBottom: "20px" }}
      >
        {/* Last Updated */}
        <Typography
          sx={{
            fontSize: { xs: "12px", sm: "14px" },
            mb: 2,
            color: "#808080",
            textAlign: "left",
          }} 
        >
          Last Updated: {privacyData.lastUpdated}
        </Typography>

        {/* Title */}
        <Typography
          variant="h2"
          gutterBottom
          sx={{
            fontSize: { xs: "23px", sm: "23px", md: "24px" },
           fontFamily: "Poppins_600SemiBold",
            mb: 2,
            textAlign: "left",
            color: "text.primary",
          }}
        >
          {privacyData.title}
        </Typography>

        {/* Intro */}
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "14px", sm: "16px", md: "18px" },
            lineHeight: 1.6,
            color: "#808080",
            mb: 2,
            fontFamily: "poppins",
            textAlign: "left",
          }}
        >
          {privacyData.intro}
        </Typography>

        {/* Sections */}
        {privacyData.sections.map((section, index) => (
          <Box key={index} sx={{ mt: { xs: 3, sm: 4 } }}>
            {/* Heading */}
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: "23px", sm: "23px", md: "24px" },
                fontFamily: "Poppins_600SemiBold",
                mb: 2,
                color: "text.primary",
                textAlign: "left",
              }}
            >
              {section.heading}
            </Typography>

            {/* Content */}
            {section.content && (
              <Typography
                sx={{
                  fontSize: { xs: "14px", sm: "16px", md: "18px" },
                  lineHeight: 1.6,
                  color: "#808080",
                  textAlign: "left",
                  fontFamily: "poppins",
                }}
              >
                {section.content}
              </Typography>
            )}

            {/* List */}
            {section.list && (
              <Box component="ul" sx={{ pl: 3, color: "text.secondary" }}>
                {section.list.map((item, i) => (
                  <li
                    key={i}
                    style={{
                      marginBottom: "8px",
                      fontSize: window.innerWidth < 600 ? "14px" : "16px",
                      // fontSize: { xs: "14px", sm: "16px" ,md:"20px"},
                      lineHeight: 1.6,
                      color: "#808080",
                      textAlign: "left",
                      fontFamily: "poppins",
                    }}
                  >
                    {item}
                  </li>
                ))}
              </Box>
            )}

            {/* SubSections */}
            {section.subSections &&
              section.subSections.map((sub, j) => (
                <Box key={j} sx={{ mt: 2 }}>
                  <Typography
                    sx={{
                   
                      mb: 1,
                      fontSize: { xs: "16px", sm: "16px" },
                      lineHeight: 1.6,
                      color: "#808080",
                      textAlign: "left",
                        fontFamily: "Poppins_600SemiBold",
                    }}
                  >
                    {sub.subHeading}
                  </Typography>
                  <Box component="ul" sx={{ pl: 3, color: "text.secondary" }}>
                    {sub.list.map((item, k) => (
                      <li
                        key={k}
                        style={{
                          marginBottom: "6px",
                          fontSize: window.innerWidth < 600 ? "14px" : "16px",
                          lineHeight: 1.6,
                          color: "#808080",
                          textAlign: "left",
                          fontFamily: "poppins",
                        }}
                      >
                        {item}
                      </li>
                    ))}
                  </Box>
                </Box>
              ))}
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
